// src/utils/feedPostAlerts.js
// Feed post alerts (Henry, 10/05/2026): "notifications go out to everyone when someone posts on the
// news feed." Right after a post is saved, the browser makes ONE call and the server rings every active
// teammate except the author: a bell and a phone push each (functions-api feedAlerts.js decides who and
// the words). Opt-out per person on the Notifications page (users.feedPostAlerts === false), like the
// @mention email. Never throws and never awaited by the caller: the post is already saved, and a missed
// alert must never look to the writer like a lost post.
import { authedFetch } from "./authedFetch";

const API_BASE = "https://us-central1-team-edelstein.cloudfunctions.net/api";

// Only an explicit false turns the alert off.
export function wantsFeedPostAlerts(u) {
  return u?.feedPostAlerts !== false;
}

// → { ok: true, notified } | { ok: true, already: true } | { ok: false, error }
export async function alertTeamAboutPost(postId) {
  const id = String(postId || "").trim();
  if (!id) return { ok: false, error: "No post id." };
  try {
    const res = await authedFetch(`${API_BASE}/feed/post-alert`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ postId: id }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      return {
        ok: false,
        error: data.error || (res.status === 404 ? "Feed alerts need the server update deployed first." : `HTTP ${res.status}`),
        status: res.status,
      };
    }
    return { ok: true, ...data };
  } catch (e) {
    // The owner's look-only view refuses every write before it leaves; that is not a failure to report.
    if (e && e.lookOnly) return { ok: false, lookOnly: true, error: "Look only." };
    return { ok: false, error: (e && e.message) || "Network error" };
  }
}

// Fire-and-forget wrapper every poster uses: logs a failure, never throws, never rejects.
export function alertTeamAboutPostInBackground(postId) {
  return alertTeamAboutPost(postId)
    .then((r) => {
      if (!r.ok && !r.lookOnly) console.error("Feed post alert failed:", r.error);
      return r;
    })
    .catch((err) => {
      console.error("Feed post alert failed:", err);
      return { ok: false, error: String((err && err.message) || err) };
    });
}
